<template>
  <div class="autoMatic_box" v-if="sonIncan" ref="autoBox" :style="{ top: posTop + 'px', left: posLeft + 'px' }">
    <!--    <div class="autoMatic_box">-->
    <!--    <div class="box_center" v-loading="incan_load">-->
    <div class="jiantou" v-show="sonIncan"></div>
    <div class="box_center">
      <div class="box_header">
        <div>
          优化后的提示词
        </div>
        <img src="@/components/images/lingganImg/close.png" class="close_img" alt="" @click="sonIncan = false">
      </div>
      <div :class="['boxBody','boxBody1']">
        <!-- <div class="box_body">
          <div class="font_title">
            <div class="china_title" style="margin-bottom:14px ">
              {{ incan_list[0].zh }}
            </div>
          </div>
          <div class="box_footer">
            <div class="foot_btn1" @click="deactivateAll('operate1',0)">
              继续使用<img src="./img/icon_img36.png" alt=" "/>
            </div>
          </div>
        </div> -->
        <!-- <div class="system_box">
          <div>
            系统优化提示词
            <span>建议使用下方提示词，视频质量更高</span>
          </div>
          <span>下方提示词可以修改</span>
        </div> -->
        <div class="box_body" v-if="index!=0" v-for="(item, index) in incan_list">
          <div v-if="!incan_load">
            <!--            <div v-if="false">-->
            <div class="font_title">
              <div class="china_title cn_inp" v-if="!item.more" @click="activateEdit(index)">
                {{ item.zh }}
              </div>
              <div class="text_inp">
              <textarea ref="textareaRefs"
                        v-model="item.zh" @blur="deactivateAll"
                        v-show="item.more" rows="3"></textarea>
              </div>
              <div class="english_title">
                {{ item.en }}
              </div>
            </div>
            <div class="box_footer">
              <div :class="['foot_btn3',index==1?'btn3_1':'btn3_2']">
                {{ index == 1 ? '基础版' : '进阶版' }}
              </div>
              <div class="foot_btn2" @click="deactivateAll('operate2',index)">
                使用它<img src="./img/icon_img36.png" alt=" "/>
              </div>
            </div>
          </div>
          <div v-else class="load_gif">
            <!--            <div class="load_gif">-->
            <img src="./img/AipromptWords.gif" alt="">
            <span>
              系统正在为您优化......{{ percentage }}%
            </span>
          </div>

          <div class="xuxian" v-if="index==1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">

export default {
  props: ['typedata', 'inpdata'],
  data() {
    return {
      sonIncan: false, // 优化咒语
      incan_load: false, //
      incan_list: [
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
      ], // 优化咒语列表
      textareaRefs: [],
      percentage: 1,  // 初始1%
      remainingTime: 10,
      interval: null,
      time: null,
      // 弹层定位
      posTop: 100,
      posLeft: 420,
    }
  },
  created() {

  },
  methods: {
    // 计算并更新弹层位置：始终在 .desc_box 右侧 20px，且垂直居中
    updatePosition() {
      this.$nextTick(() => {
        const target = document.querySelector('#only_desc');
        const box = this.$refs.autoBox;
        if (!target || !box) return;
        const rect = target.getBoundingClientRect();
        const boxRect = box.getBoundingClientRect();
        const left = rect.right + 10; // 右侧 20px
        const top = Math.max(10, Math.round(rect.top + rect.height / 2 - boxRect.height / 2));
        this.posLeft = left;
        this.posTop = top;
      });
    },
    bindPositioning() {
      // 绑定窗口事件保持位置同步
      if (!this._boundUpdatePosition) {
        this._boundUpdatePosition = this.updatePosition.bind(this);
      }
      window.addEventListener('resize', this._boundUpdatePosition);
      window.addEventListener('scroll', this._boundUpdatePosition, { passive: true });
      // 初次计算
      this.updatePosition();
      // 延迟几次再算，防止图片/字体加载导致尺寸变化
      // setTimeout(this.updatePosition, 100);
      // setTimeout(this.updatePosition, 300);
      // setTimeout(this.updatePosition, 600);
    },
    unbindPositioning() {
      if (this._boundUpdatePosition) {
        window.removeEventListener('resize', this._boundUpdatePosition);
        window.removeEventListener('scroll', this._boundUpdatePosition);
      }
    },
    hide_box(){
      this._boundHandleGlobalClick = this.handleGlobalClick.bind(this);
      window.addEventListener('click', this._boundHandleGlobalClick, true);
    },
    handleGlobalClick(e) {
      if(!this.sonIncan) return
      const searchWrap = this.$refs.autoBox;
      const target = e.target;
      // 如果点击发生在搜索区域内，则不关闭
      const inSearchArea = (searchWrap && (searchWrap === target || searchWrap.contains(target)));
      if (inSearchArea) return;
      this.sonIncan = false
    },
    show(type) {
      if (type == true) {
        this.sonIncan = true
        this.$nextTick(() => {
          this.bindPositioning();
          this.updatePosition();
          this.hide_box()
        });
        this.deactivateAll('post')
      } else {
        this.sonIncan = false
        this.incan_list = [
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
        ]
        this.unbindPositioning();
      }

    },
    activateEdit(index) {
      // 先关闭所有编辑框
      // 打开当前项的编辑状态
      console.log('index', index)
      this.incan_list.forEach((item, i) => {
        if (index == i) {
          console.log('true')
          item.more = true
          this.$nextTick(() => {
            this.$refs.textareaRefs[index - 1].focus();
          });
        } else {
          console.log('false')
          item.more = false
        }
      });
      // 等待DOM更新后聚焦
      console.log('textareaRefs', this.$refs.textareaRefs)

    },
    deactivateAll(type, index) {
      if (type === 'operate1' || type === 'operate2') {
        console.log('this.typedata', this.typedata)
        this.$emit('getPromptData1', this.incan_list[index].zh.trim())
      } else if (type === 'post') {
        this.incan_list = [
          {zh: this.inpdata, en: '', more: false},
          {zh: '', en: '', more: false},
          {zh: '', en: '', more: false}
        ];
        this.sonIncan = true
        this.incan_load = true
        this.opentimer()
        // console.log(1111111111)
        this.$http.post('/front/aivideo/prompt/',
            {question: this.inpdata, type: this.typedata,}).then((res) => {
          this.incan_load = false
          if (res.status == 200) {
            this.incan_list = [
              {zh: this.inpdata, en: '', more: false},
              {zh: res.data.higt1.zh, en: res.data.higt1.en, more: false},
              {zh: res.data.higt2.zh, en: res.data.higt2.en, more: false}
            ];
            console.log(this.incan_list)
            clearInterval(this.interval);
            this.percentage = 0
            this.updatePosition()
          } else {
            console.log('失败')
            this.$message.error("你提交的内容涉及敏感信息,请修改后重新提交！")
            this.incan_load = false
            this.sonIncan = false
          }
        }).catch((err) => {
          console.log('失败err', err)
          this.$message.error(err.message)
          this.incan_load = false
          this.sonIncan = false
        })
      } else {
        this.incan_list.forEach((e, i) => {
          e.more = false
        });
      }
    },
    opentimer() {
      // 更新剩余时间
      this.interval = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0 && this.percentage >= 99) {
          this.stopTimer()
        }
      }, 1000);

      // 更新随机百分比
      this.timer = setInterval(() => {
        this.percentage += Math.floor(Math.random() * 5) + 1;
        if (this.percentage >= 99) {
          this.percentage = 99
        }
      }, 500); // 每300毫秒更新一次随机值
    },
    stopTimer() {
      clearInterval(this.timer);
      clearInterval(this.interval);
    },

  },
};


</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// 自动优化
.autoMatic_box {
  // width: 100%;
  // height: 100%;
  position: fixed;
  top: 100px;
  left: 420px;
  // background-color: rgba(0, 0, 0, 0.8);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  line-height: 1.4;
  .jiantou{
    //左箭头
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    border-right: 9px solid #10151f;
    z-index: 1;
  }

  .box_center {
    width: 550px;
    //min-height: 550px;
    //max-height: 760px;
    border-radius: 10px;
    border: 2px solid #5865f2;
    background-color: #000;
    overflow: hidden;

    .box_header {
      background-color: #5865f2;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;
      .close_img{
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    

    .boxBody {
      overflow: auto;

      .box_body {
        font-size: 14px;
        padding: 0 14px;
        margin: 14px 0;

        .load_gif {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          img {
            width: 150px;
          }

          span {
            margin-bottom: 10px;
          }
        }

        .font_title {
          line-height: 1.2;

          .china_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.6;
            color: #aaa;

            &.cn_inp {
              cursor: pointer;
            }
          }

          .english_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.4;
            word-break: break-all;
            color: #997a48;
            margin: 14px 0;
          }

          .text_inp {
            textarea {
              width: 100%;
              padding: 5px 8px;
              border-radius: 4px;
              border: 2px solid #5865f2;
            }
          }
        }

        .box_footer {
          display: flex;
          justify-content: flex-end;

          .foot_btn1, .foot_btn2, .foot_btn3 {
            cursor: pointer;
            color: #fff;
            font-size: 14px;
            width: 110px;
            padding: 10px 14px;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;

            img {
              width: 10px;
              height: 10px;
              margin-left: 6px;
            }
          }

          .foot_btn1 {
            background-color: #5865f2;

          }

          .foot_btn2 {
            background-color: #997a48;
          }

          .foot_btn3 {
            width: 95px;
            margin-right: 10px;
            background-color: #333333;
            cursor: auto;

            &.btn3_1 {
              color: #999;

            }

            &.btn3_2 {
              color: #997a48;
            }
          }

        }

        .xuxian {
          width: 100%;
          border-top: 1px dashed #666666;
          margin-top: 14px;
        }
      }
    }

    .system_box {
      background-color: #333333;
      padding: 10px 10px;
      color: white;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;

      span {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}

/* 当屏幕高度在900-1100px范围内时应用 */
@media screen and (min-height: 0) and (max-height: 600px) {
  .boxBody1 {
    min-height: 500px;
    max-height: 500px;
  }
}

@media screen and (min-height: 600px) and (max-height: 700px) {
  .boxBody1 {
    min-height: 550px;
    max-height: 600px;
  }
}

@media screen and (min-height: 700px) and (max-height: 800px) {
  .boxBody1 {
    min-height: 550px;
    max-height: 650px;
  }
}

@media screen and (min-height: 800px) {
  .boxBody1 {
    min-height: 350px;
    max-height: 610px;
  }
}

</style>